module.exports = __webpack_public_path__ + "b2cd5a9a011fd43f115a2c5e2c9f91e5.svg";